// mixpanel-browser her XHR'da withCredentials'ı koşulsuz true yapar
// (SDK: src/mixpanel-core.js, mp_optout cookie için; init seçeneği yok).
// Gateway Cookie/Authorization'ı zaten sildiğinden credential'ların işlevi yok;
// bu patch YALNIZCA Mixpanel proxy isteklerinde withCredentials'ı false'a çeker.
// Kapsam: sadece XHR. Unload flush'ları sendBeacon+text/plain (simple request)
// olduğu için zaten teslim edilir.
// Session replay bu patch'in kapsamı DIŞINDA: recorder XHR değil fetch kullanır ve
// record_sessions_percent=0 ile kapalı. (Replay /record 401 kök nedeni: gateway /mp
// route'u Authorization header'ını siliyor — replay açılacaksa önce gateway'de /record
// için Authorization korunmalı.)

const PATCHED = Symbol.for('doktar.mpXhrCredPatch');

export function patchMixpanelXhrCredentials(isMixpanelUrl: (url: string) => boolean): void {
  if (typeof XMLHttpRequest === 'undefined') return; // SSR/prerender guard
  const proto = XMLHttpRequest.prototype as any;
  if (proto[PATCHED]) return; // idempotent
  proto[PATCHED] = true;

  const origOpen = proto.open;
  proto.open = function (this: any, method: string, url: string | URL, ...rest: unknown[]) {
    try {
      this.__mpNoCreds = isMixpanelUrl(String(url));
    } catch {
      this.__mpNoCreds = false;
    }
    return origOpen.call(this, method, url, ...rest);
  };

  const origSend = proto.send;
  proto.send = function (this: any, ...args: unknown[]) {
    if (this.__mpNoCreds && this.withCredentials) {
      try {
        this.withCredentials = false;
      } catch {
        // asla fırlatma
      }
    }
    return origSend.apply(this, args);
  };
}
